module.exports = __webpack_public_path__ + "img/logo_7.08d6fab7.png";